import SignupCompleted from './signupCompleted'

export default SignupCompleted
